import { Routes, Route } from "react-router-dom";
import React from "react";

import "./styles/main.css";

// import Dashboard from "./pages/dashboard.js";
import Login from "./pages/login.js";
import Refunds from "./pages/refunds";
import Wrapper from "./pages/wrapper";
import ResetPassword from "./pages/reset";
import ResetPasswordCommit from "./pages/reset.commit";
import Users from "./pages/users";
import Credits from "./pages/credits";
import Invoices from "./pages/invoices";
import Settings from "./pages/settings";
import Impersonate from "./pages/impersonate.js";
import ImpersonationTitle from "./components/title_impersonate.js";
import Messages from "./pages/messages.js";
import Notice from "./pages/notice.js";
import Maintenance from "./pages/maintenance.js";
import Blocked from "./pages/blocked.js";

import Store from "./global/global";
import { ImpersonationProvider } from "./global/impersonation.js";
import { MessagesProvider, useMessages } from "./global/messagesContext.js";

function App() {

  return (
    <ImpersonationProvider>
      <MessagesProvider>
        <Store>
          <ImpersonationTitle />
          <InnerApp />
        </Store>
      </MessagesProvider>
    </ImpersonationProvider>

  );
}

function InnerApp() {
  const { data, blockScreens } = useMessages();

  const checkBlockedRoute = (param) => {
    return blockScreens.includes('all_access_admin') || blockScreens.includes(param);
  }

  return (
    <Routes>
      <Route path="/refunds" element={<Wrapper screen={checkBlockedRoute("page_refunds_admin") ? <Maintenance title="Despesas" /> : <Refunds />} />} />
      <Route path="/users" element={<Wrapper screen={checkBlockedRoute("page_users_admin") ? <Maintenance title="Usuários" /> : <Users />} />} />
      <Route path="/credits" element={<Wrapper screen={checkBlockedRoute("page_credits_admin") ? <Maintenance title="Créditos" /> : <Credits />} />} />
      <Route path="/invoices" element={<Wrapper screen={<Invoices />} />} />
      <Route path="/settings" element={<Wrapper screen={checkBlockedRoute("settings_admin") ? <Maintenance title="Configurações" /> : <Settings />} />} />
      <Route path="/impersonate" element={<Wrapper screen={<Impersonate />} />} />
      <Route path="/notice" element={<Wrapper screen={(data && data.length > 0) ? <Notice /> : <Maintenance title="Avisos" isNotice={true} />} />} />
      <Route path="/messages" element={<Wrapper screen={<Messages />} />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/reset/:token" element={<ResetPasswordCommit />} />
      <Route path="/blocked" element={<Blocked />} />
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Wrapper screen={checkBlockedRoute("page_refunds_admin") ? <Maintenance title="Despesas" /> : <Refunds />} />} />
    </Routes>
  );
}

export default App;
